import { createEpicMiddleware, combineEpics } from "redux-observable"

import { scheduleFetchDataEpic, scheduleCUDEpic, scheduleFetchAfterCUDEpic } from "./schedule"
import { userPurchaseCreditsEpic } from "./user"

const epics = combineEpics(
    scheduleFetchDataEpic,
    scheduleFetchAfterCUDEpic,
    scheduleCUDEpic,
    userPurchaseCreditsEpic
)

const epicMiddleware = createEpicMiddleware(epics)

export default epicMiddleware